export default __webpack_public_path__ + "static/media/H0007.f22ed1e5.png";